module.exports = __webpack_public_path__ + "public/SiteIcons/pdf_image.png?dfb7987e";